export {default} from "./Search";


// WEBPACK FOOTER //
// ./src/components/Search/index.js